'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App', 'Messages');

function mapStateToProps(state) {
    return {
        cart: state.cart
    };
}

var SummaryBox = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(SummaryBox, _React$PureComponent);

    function SummaryBox() {
        (0, _classCallCheck3.default)(this, SummaryBox);
        return (0, _possibleConstructorReturn3.default)(this, (SummaryBox.__proto__ || (0, _getPrototypeOf2.default)(SummaryBox)).apply(this, arguments));
    }

    (0, _createClass3.default)(SummaryBox, [{
        key: 'render',
        value: function render() {
            var cart = this.props.cart;
            var coupon = cart.coupon,
                voucher = cart.voucher,
                deliveryPrice = cart.deliveryPrice;

            var totalProductsPrice = cart.totalProductsPrice.finalPrice || 0;
            var totalDiscount = coupon && coupon.info && coupon.info.appliedValue || 0;
            totalProductsPrice += totalDiscount;
            var transportPrice = deliveryPrice || 0;

            var totalPrice = totalProductsPrice - totalDiscount + transportPrice || 0;
            var roundingValue = 0.0;
            var voucherAppliedPrice = totalPrice - (voucher ? voucher.info.appliedValue : 0);
            var roundingEnabled = false;

            if (cart.roundingPrecision && cart.roundingPrecision[cart.paymentTypeId]) {
                var precision = cart.roundingPrecision[cart.paymentTypeId];
                var originalPrice = totalPrice;
                totalPrice = Math.round(totalPrice / precision) * precision;
                roundingValue = originalPrice - totalPrice;
                voucherAppliedPrice = Math.round(voucherAppliedPrice / precision) * precision;
                roundingEnabled = true;
            }
            var totalPriceCss = voucher ? "cart__item" : "cart__item cart__item--last";

            return _react2.default.createElement(
                'div',
                { className: 'cart__summary' },
                _react2.default.createElement(
                    'h3',
                    null,
                    Resx.App.Overview
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart__item' },
                    _react2.default.createElement(
                        'div',
                        null,
                        Resx.App.TotalGoodsWithVAT
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__summary', id: 'productsTotalWithVat' },
                            (0, _linksoftAlbatros.formatPrice)(totalProductsPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                        )
                    )
                ),
                totalDiscount > 0 && _react2.default.createElement(
                    'div',
                    { className: 'cart__item' },
                    _react2.default.createElement(
                        'div',
                        null,
                        Resx.App.TotalDiscount
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__summary', id: 'cartTotalDiscount' },
                            '-',
                            (0, _linksoftAlbatros.formatPrice)(totalDiscount, _linksoftAlbatros.PriceType.CartTotalPrice)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart__item' },
                    _react2.default.createElement(
                        'div',
                        null,
                        Resx.App.TransportationFee
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__summary', id: 'cartTransportationFee' },
                            (0, _linksoftAlbatros.formatPrice)(transportPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: totalPriceCss },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'strong',
                            { className: 'title h4' },
                            Resx.Common.Total
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__summary', id: 'cartTotalWithVat' },
                            (0, _linksoftAlbatros.formatPrice)(totalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                        )
                    )
                ),
                voucher && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__item' },
                        _react2.default.createElement(
                            'div',
                            null,
                            voucher.name
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'cart-i__summary' },
                                (0, _linksoftAlbatros.formatPrice)(-voucher.nominalValue, _linksoftAlbatros.PriceType.CartTotalPrice)
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__item cart__item--last' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'strong',
                                { className: 'title h4' },
                                Resx.App.PaymentPrice
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'cart-i__summary' },
                                (0, _linksoftAlbatros.formatPrice)(voucherAppliedPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                            )
                        )
                    )
                ),
                roundingEnabled && _react2.default.createElement('div', { className: 'inline-help inline-help-smaller',
                    dangerouslySetInnerHTML: { __html: Resx.Messages.RoundingInfo } })
            );
        }
    }]);
    return SummaryBox;
}(_react2.default.PureComponent), _class2.propTypes = {
    cart: _propTypes2.default.object
}, _temp)) || _class);
exports.default = SummaryBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step2/SummaryBox.js
// module id = 1028
// module chunks = 0